/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {useMemo} from 'react';
import {makeStyles} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import {FormRadioGroup} from '@ion/dls/src/components/forms/FormRadioGroup';
import {GroupAssignmentActions} from './types';
import {UseGroupAssignmentChooserResult} from './useGroupAssignmentChooser';

const useStyles = makeStyles(() => ({
  root : {
    padding : '0px !important',
    margin  : '0px !important'
  }
}));

/**
 The GroupAssignmentActionChooser provides a list of actions for display within a
 * radio button allowing the user to select a action.
 */
export const GroupAssignmentActionChooser = ({
  handleActionChooser,
  groupAction
}: UseGroupAssignmentChooserResult) => {
  const classes = useStyles();

  const groupOptions = useMemo(() => ([{
    label    : translate('common:editors.bulkActions.groupAssignment.addToGroup'),
    value    : GroupAssignmentActions.Add,
    disabled : false
  },
  {
    label    : translate('common:editors.bulkActions.groupAssignment.removeFromGroup'),
    value    : GroupAssignmentActions.Remove,
    disabled : false
  },
  {
    label    : translate('common:editors.bulkActions.groupAssignment.replaceGroup'),
    value    : GroupAssignmentActions.Replace,
    disabled : false
  }]), []);

  return (
    <div className={classes.root}>
      <FormRadioGroup required
        displayAsRow
        name={'groupAction'}
        options={groupOptions}
        defaultValue={groupAction}
        groupLabel={translate('common:editors.bulkActions.groupAssignment.actions')}
        onChange={handleActionChooser} />
    </div>
  );
};

export default GroupAssignmentActionChooser;
